export const ERROR = "ERROR";

export const LOAD_QUESTIONNAIRE = "LOAD_QUESTIONNAIRE";
export const RESET_QUESTIONNAIRE = "RESET_QUESTIONNAIRE";
export const UPDATE_QUESTIONNAIRE = "UPDATE_QUESTIONNAIRE";

export const LOAD_PROJECT_ANALYSIS_REPORT = "LOAD_PROJECT_ANALYSIS_REPORT";
export const FILTER_PROJECT_ANALYSIS_REPORT = "FILTER_PROJECT_ANALYSIS_REPORT";
export const UPDATE_FILTERS_APPLIED = "UPDATE_FILTERS_APPLIED";
export const UNPIN_CLIP = "UNPIN_CLIP";
export const CREATE_NEW_HIGHLIGHT_REEL = "CREATE_NEW_HIGHLIGHT_REEL";
export const ADD_CLIP_TO_HIGHLIGHT_REEL = "ADD_CLIP_TO_HIGHLIGHT_REEL";
export const REMOVE_CLIP_FROM_HIGHLIGHT_REEL = "REMOVE_CLIP_FROM_HIGHLIGHT_REEL";
export const REORDER_CLIPS_IN_HIGHLIGHT_REEL = "REORDER_CLIPS_IN_HIGHLIGHT_REEL";
export const DOWNLOAD_HIGHLIGHT_REEL = "DOWNLOAD_HIGHLIGHT_REEL";
export const GET_DOWNLOAD_HIGHLIGHT_REEL_STATUS = "GET_DOWNLOAD_HIGHLIGHT_REEL_STATUS";
export const RESET_PROJECT_ANALYSIS_REPORT = "RESET_PROJECT_ANALYSIS_REPORT";
export const DELETE_HIGHLIGHT_REEL = "DELETE_HIGHLIGHT_REEL";
export const ADD_INSIGHT = "ADD_INSIGHT";
export const UPDATE_INSIGHT = "UPDATE_INSIGHT";
export const DELETE_INSIGHT = "DELETE_INSIGHT";

export const TEST = {
  LOAD: "TEST_LOAD",
  RESET: "TEST_RESET",
  UPDATE: "TEST_UPDATE",
  SHOW_UPDATE_CONFIRMATION_MODAL: "TEST_SHOW_UPDATE_CONFIRMATION_MODAL",
  UPDATE_SCREENER: "UPDATE_SCREENER",
  ADD_SCREENER_QUESTION: "ADD_SCREENER_QUESTION",
  DUPLICATE_SCREENER_QUESTION: "DUPLICATE_SCREENER_QUESTION",
  CONFIRMATION_FOR: { TASK_LOGIC: "TASK_LOGIC", TASK_USEPRETASKURL: "TASK_USEPRETASKURL" },
};

export const USER = {
  LOGOUT: "LOGOUT",
  RESET: "RESET_USER",
  UPDATE: "UPDATE_USER",
  UPDATE_DATA: "UPDATE_DATA",
  UNAUTHORIZED: "UNAUTHORIZED",
  TOGGLE_AIOPTIN: "TOGGLE_AIOPTIN",
  UPDATE_BILLINGS: "UPDATE_BILLINGS",
  UPDATE_ORG_PEOPLE_WORK_MEMBERS: "UPDATE_ORG_PEOPLE_WORK_MEMBERS",
};

export const TEST_PREVIEW = {
  LOAD: "PREVIEW_LOAD",
  ERROR: "PREVIEW_ERROR",
  UPDATE: "PREVIEW_UPDATE",
};

export const COMMENTS = {
  LOAD: "COMMENTS_LOAD",
  UPDATE: "COMMENTS_UPDATE",
  RESET: "COMMENTS_RESET",
  ERROR: "COMMENTS_ERROR",
  ADD_COMMENT: "COMMENTS_ADD_COMMENT",
  UPDATE_COMMENT: "COMMENTS_UPDATE_COMMENT",
  UPDATE_REACTION: "COMMENTS_UPDATE_REACTION",
  SET_SELECTED_FILTER: "COMMENTS_SET_SELECTED_FILTER",
  SET_SHOW_RESOLVED_COMMENTS: "COMMENTS_SET_SHOW_RESOLVED_COMMENTS",
  MARK_AS_READ: "COMMENTS_MARK_AS_READ",
};

export const TEST_TAB_KEYS = { CREATE: "CREATE", RECRUIT: "RECRUIT", REPORT: "REPORT", ANALYSIS_SPACE: "ANALYSIS-SPACE" };

export const TEMPLATES = {
  LOAD: "TEMPLATES_LOAD",
  UPDATE: "TEMPLATES_UPDATE",
  RESET: "TEMPLATES_RESET",
  ERROR: "TEMPLATES_ERROR",
  ADD_TEMPLATE: "TEMPLATES_ADD_TEMPLATE",
  SET_SELECTED_FILTERS: "TEMPLATES_SET_SELECTED_FILTERS",
};

export const REPORT = {
  LOAD: "REPORT_LOAD",
  RESET: "REPORT_RESET",
  ERROR: "REPORT_ERROR",
  UPDATE: "REPORT_UPDATE",
  SET_SELECTED_FILTERS: "REPORT_SET_SELECTED_FILTERS",
  HEATMAP_UPDATE: "HEATMAP_UPDATE",
  AI_SUMMARY_UPDATE: "AI_SUMMARY_UPDATE",
};

export const REPORT_TAB_KEYS = {
  TASKS: "TASKS",
  OVERVIEW: "OVERVIEW",
  SCREENER: "SCREENER",
  RESPONSES: "RESPONSES",
  SUS_SCORE: "SUS_SCORE",
  ANALYSIS_SPACE: "ANALYSIS_SPACE",
};

export const DASHBOARD = {
  LOAD: "DASHBOARD_LOAD",
  RESET: "DASHBOARD_RESET",
  ERROR: "DASHBOARD_ERROR",
  UPDATE: "DASHBOARD_UPDATE",
};

export const BROWSER_TEST = {
  RESET: "BROWSER_TEST_RESET",
  UPDATE: "BROWSER_TEST_UPDATE",
  ERROR: "BROWSER_TEST_ERROR",
};

export const DASHBOARD_MODERATED = {
  LOAD: "DASHBOARD_MODERATED_LOAD",
  RESET: "DASHBOARD_MODERATED_RESET",
  ERROR: "DASHBOARD_MODERATED_ERROR",
  UPDATE: "DASHBOARD_MODERATED_UPDATE",
  PROJECT_MODAL_CONFIG: "DASHBOARD_MODERATED_PROJECT_MODAL_CONFIG",
};

export const DASHBOARD_COMMON = {
  LOAD: "DASHBOARD_COMMON_LOAD",
  RESET: "DASHBOARD_COMMON_RESET",
  ERROR: "DASHBOARD_COMMON_ERROR",
  UPDATE: "DASHBOARD_COMMON_UPDATE",
};

export const PLANS = { LOAD: "PLANS_LOAD", UPDATE: "PLANS_UPDATE", RESET: "PLANS_RESET" };
